export enum WriteToUsInquiryType {
  BUG = 'bug',
  QUESTION = 'question',
  FEEDBACK = 'feedback',
  REQUEST_CALLBACK = 'request_callback',
  MAILROOM = 'mailroom',
}
